import React from 'react';
import './Features.css';

const Features = () => {
  return (
    <section className="features-section" id="features">
      <h2 className="features-title">Our Team</h2>
      <div className="features-list">

        <div className="feature-item">
          <div className="feature-content">
            <p className="feature-description">
              ❝ Shouvik Roy brings creativity and strategy together as a Social Media Analyst. With a year of real-time experience, he specializes in boosting online engagement and brand awareness across platforms through data-driven campaigns and live response handling. ❞
            </p>
            <span className="feature-name">— Shouvik Roy, Social Media Analyst</span>
          </div>
        </div>

        <div className="feature-item">
          <div className="feature-content">
            <p className="feature-description">
              ❝ Somnath Chatterjee is a passionate Java trainer with hands-on expertise in core and advanced Java. He excels in simplifying complex concepts for students and developers alike, offering practical guidance and live problem-solving throughout the learning journey. ❞
            </p>
            <span className="feature-name">— Somnath Chatterjee, Java Trainer</span>
          </div>
        </div>

        <div className="feature-item">
          <div className="feature-content">
            <p className="feature-description">
              ❝ Sravya Saran is a cybersecurity trainer with in-depth knowledge of ethical hacking, network defense, and security auditing. With 1 year of experience, she conducts interactive sessions with live demonstrations to build real-world cyber awareness and skills. ❞
            </p>
            <span className="feature-name">— Sravya Saran, Cybersecurity Trainer</span>
          </div>
        </div>

        <div className="feature-item">
          <div className="feature-content">
            <p className="feature-description">
              ❝ Akshay Kapurkar, our Sourcing Specialist, has a proven track record in finding top talent and managing recruitment pipelines. His 1-year experience in real-time candidate engagement helps teams hire smarter and faster with live tracking and updates. ❞
            </p>
            <span className="feature-name">— Akshay Kapurkar, Sourcing Specialist</span>
          </div>
        </div>

        <div className="feature-item">
          <div className="feature-content">
            <p className="feature-description">
              ❝ Tharun Kumar is an enthusiastic MERN stack trainer who blends theory with real-world projects. With expertise in MongoDB, Express, React, and Node.js, he mentors learners by offering live code walkthroughs and hands-on full stack development support. ❞
            </p>
            <span className="feature-name">— Tharun Kumar, MERN Stack Trainer</span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Features;
